import { Extension } from '@tiptap/core';
import userSettingsEngine from '../../controllers/UserSettings/UserSettingsEngine';
import { emsToDisplay } from '../../services/utils/DateFormat';

/**
 * DateTimeExtension — inserts current date/time at cursor via Ctrl+Alt+D.
 * Format comes from user setting contentPanel.chipDateTimeFormat.
 */
export const DateTimeExtension = Extension.create({
    name: 'dateTime',

    addKeyboardShortcuts() {
        return {
            'Ctrl-Alt-d': () => {
                const fmt = userSettingsEngine.resolve('contentPanel.chipDateTimeFormat');
                const text = emsToDisplay(Date.now(), fmt);
                return this.editor.chain().focus().insertContent(text).run();
            },
        };
    },
});
